import { Icon, ICONS } from 'components/Icons';
import moment from 'moment';
import React, { useState } from 'react';
import { renderCheck } from 'routes/Portfolio/Component/ActivityTab/TopicsTab/helper';
import DailyCheckInHistory from './DailyCheckInHistory';

export default function DailyCheckInRow({ user, actions }) {
  const [expanded, setExpanded] = useState(false);

  const checkIn = user.lastDailyCheckIn;

  const name =
    user.profile?.firstName && user.profile?.lastName
      ? `${user.profile.firstName} ${user.profile.lastName}`
      : user.username || user.email;

  const schools =
    user.schools?.length > 0
      ? user.schools.map((s) => s.displayName).join(', ')
      : '-';

  return (
    <>
      <tr className="cursor-pointer" onClick={() => setExpanded(!expanded)}>
        <td>
          <Icon
            icon={expanded ? ICONS.CHEVRON_DOWN : ICONS.CHEVRON_RIGHT}
            className="mr-2 mt-1 font-size-16"
          />
        </td>
        <td>{name}</td>
        <td>{user.email}</td>
        {/* <td>{schools}</td> */}

        <td className="text-center">{renderCheck(checkIn?.isLoggedIn)}</td>
        <td className="text-center">{renderCheck(checkIn?.isPinned)}</td>

        <td className="text-center">
          {checkIn?.time
            ? moment(checkIn.time).format('MM/DD/YYYY HH:mm')
            : '-'}
        </td>
        <td className="text-center">{checkIn?.device || '-'}</td>
        <td className="text-center">{checkIn?.browser || '-'}</td>
        <td className="text-center">{checkIn?.version || '-'}</td>
      </tr>
      {expanded ? <DailyCheckInHistory user={user} actions={actions} /> : null}
    </>
  );
}
